<template>
  <section role="modal">
    <div
      class="modal fade"
      id="regraDiasPendentesModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="regraDiasPendentesModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="regraDiasPendentesModalLabel">
              Dias de Férias Pendentes
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px">
              <div class="col-md-12 col-sm-12">
                <p>Você tem dias pendentes de férias!</p>
                <p>
                  Conforme item 4 da O.S. nº 02/2014 GP, os dias restantes de
                  férias deverão ser gozados de uma única vez, antes do gozo das
                  próximas férias.
                </p>
                <p>
                  Você poderá fazer o agendamento na
                  tela seguinte, mas deverá agendar em paralelo os seus dias restantes
                  através de memorando enviando e-mail para
                  o endereço ferias@santos.sp.gov.br
                </p>
                <p class="alerta">
                  ATENÇÃO, o não cumprimento do disposto acima implicará na perda do direito
                  ao gozo dos dias restantes.
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              estilo="cheio-verde"
              rotulo="Ciente"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from '@/components/botao';

export default {
  name: 'ExplicacaoModal',

  components: {
    Botao,
  },
};
</script>

<style scoped>
  .alerta {
    color: #FF3C3C;
  }
</style>



// WEBPACK FOOTER //
// regra-dias-pendentes-modal.vue?629ed22e